import { PricePlanFeature } from "../../core/contexts/PricePlanFeatureContext/PricePlanFeatureContext";
import { SettingsLangFactory } from "../../core/lang";

export const getPricePlanFeatureAddOnName = (feature: PricePlanFeature) => {
	const settingsLang = SettingsLangFactory();

	switch (feature) {
		case PricePlanFeature.Invoicing:
			return settingsLang.PricePlanFeature_Invoicing;

		case PricePlanFeature.AutomaticBankImport:
			return settingsLang.PricePlanFeature_AutomaticBankImport;

		case PricePlanFeature.PublicApi:
			return settingsLang.PricePlanFeature_PublicApi;

		case PricePlanFeature.Tags:
			return settingsLang.PricePlanFeature_Tags;

		default:
			throw new Error("Feature not supported for addon name: " + feature);
	}
};
